<template>
  <b-container>
    <div class="thankyou-page mt-100 vh-100 d-flex align-items-center justify-content-center" v-if="hideThankyou">
      <b-card-group deck>
        <b-card class="px-4 py-4 text-center">
          <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" fill="#F15B26" class="bi bi-check2-square m-auto" viewBox="0 0 16 16">
            <path d="M3 14.5A1.5 1.5 0 0 1 1.5 13V3A1.5 1.5 0 0 1 3 1.5h8a.5.5 0 0 1 0 1H3a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V8a.5.5 0 0 1 1 0v5a1.5 1.5 0 0 1-1.5 1.5H3z"/>
            <path d="m8.354 10.354 7-7a.5.5 0 0 0-.708-.708L8 9.293 5.354 6.646a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0z"/>
          </svg>
          <h2 class="mt-4 fw-600">{{verificationMsghead}}</h2>
          <h6 class="mt-0 mb-0 text-muted">{{ verificationMsg }}.</h6>
        </b-card>
      </b-card-group>
    </div>
  </b-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { socket } from "../plugin/socket";
export default {
  data() {
    return {
      verificationMsg: '',
      hideThankyou: true,
      userDetail: '',
      count: 0,
      chat_room_id: '',
      chat_invitation_id: '',
      verificationMsghead:  '',
    };
  },

  beforeCreate() {
    console.log('beforeCreate', this.$route.params.id, this.$route.params.cid);
    if (!this.$route.params.id || !this.$route.params.cid) {
      this.$router.push("/login").catch(() => {});
      return;
    }
    this.$store.commit("setByPassEvent", "acceptChatInvitation");
  },

  created() {
    console.log("byPassEvent before mounted:", this.$store.state.byPassEvent);
  },

  computed: {
    ...mapGetters(["getsocketConnected","getsocketId"]),
  },
  watch: {
    
  },
  mounted() {
    this.chat_invitation_id = this.decodeId(this.$route.params.id);
    this.chat_room_id = this.decodeId(this.$route.params.cid)
    this.verifyAccounts(); // Emit event after connection
  },
  methods: {
    ...mapActions(["genericAPIPOSTRequest", "genericAPIGETForNodeRequestResponse", "UpdateByPassEvent"]),
    // this fun is for to verify chat invitation
    async verifyAccounts(){
        var request = {
          chat_room_id: this.chat_room_id,
          chat_invitation_id: this.chat_invitation_id,
        };
        console.log('invitationId',request);
        console.log("acceptChatInvitation-socket-request", request);
        console.log("socket", socket ,this.getsocketId);
        // Retry logic to emit until socket is connected
      const attemptEmit = () => {
        if (socket && socket.connected) {
          console.log("Socket connected, emitting event to accept chat invitation...");

          // Emit the event to the server
          socket.emit('acceptChatInvitation', request, (response) => {
            console.log("acceptChatInvitation-socket-response", response);
            if (response.success == true) {
              this.verificationMsg = response.message;
              setTimeout(() => {
                this.hideThankyou = false;
              }, 2000);

              this.verificationMsghead = 'Great Job';
              this.$toastr.s("Conversation Accepted successfully.");
              if(this.$store.state.accountType == 'freelancer'){
                this.$store.commit("setByPassEvent", "");
                window.location.href = '/freelancer';
              }else if(this.$store.state.accountType == 'agency'){
                this.$store.commit("setByPassEvent", "");
                window.location.href = '/agency/search';
              }else if(this.$store.state.accountType == 'client'){
                this.$store.commit("setByPassEvent", "");
                window.location.href = '/client/dashboard';
              }else{
                this.$store.commit("setByPassEvent", "");
                this.logout('v');
                this.$router.push("/login").catch(() => {});
              }
            } else {
              this.logout('v');
              this.verificationMsghead = 'Invalid Link';
              this.verificationMsg = response.message;
              console.log('response.message',response.message)
              this.$toastr.e(response.message);
              // this.$router.push("/login").catch(() => {});
            }
          });
        } else {
          console.log('Socket not connected. Retrying to emit acceptChatInvitation...');
          // Retry if socket is not connected
          setTimeout(attemptEmit, 1000); // Retry every 1 second (adjust as needed)
        }
      };
      attemptEmit(); // Start the retry process when the component is mounted
    },
  }
};
</script>

<style scoped>
  .thankyou-page {
    position: relative;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  /* Your existing CSS styles */
</style>
